import { IInventoryMasterDetail } from '../interfaces/IInventoryMasterDetail.interface';

export class InventoryMasterDetail implements IInventoryMasterDetail {
	Id: number;
	AnimalName: string;
    Dame: string;
    DameId?: number;
    Sire: string;
    SireId?: number;
    Internal: number;
    HatchDate: Date;
    Sex: string;
    SourceBreeder: string;
    LocationId: string;
    AnimalID: string;
    Description: string;
    InventoryTypeId: number;
    GroupId: number;
    ForSale: boolean;
    ForLoan: boolean;
    Avatar: string; //base64Image
}


// WEBPACK FOOTER //
// ./src/app/models/InventoryMasterDetail.ts